import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

const useTradingInstruments = ({
  query,
  withPriceUsd,
}: {
  query: string
  withPriceUsd?: boolean
}) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_instruments", { query: query, withPriceUsd: withPriceUsd }],
    () => scientApi.trading.getTradingInstruments({ query: query, withPriceUsd: withPriceUsd }),
    {
      retry: 1,
      staleTime: withPriceUsd ? 0 : Infinity,
      enabled: query.length >= 2, // Only fetch when query length is >= 2
    },
  )

  return {
    instruments: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingInstruments
